import React from 'react';
import { Link } from 'react-router-dom';

const PageHeader = ({ title, subtitle, action, breadcrumbs = [] }) => {
  return (
    <div className='bg-white shadow-sm border-b border-gray-200 px-6 py-4 mb-6'>
      {/* Breadcrumbs */}
      {breadcrumbs.length > 0 && (
        <nav className='flex mb-2' aria-label='Breadcrumb'>
          <ol className='flex items-center space-x-2 text-sm'>
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1;
              return (
                <li key={index} className='flex items-center'>
                  {index > 0 && (
                    <svg
                      className='flex-shrink-0 h-4 w-4 text-gray-400 mx-2'
                      xmlns='http://www.w3.org/2000/svg'
                      fill='currentColor'
                      viewBox='0 0 20 20'
                      aria-hidden='true'
                    >
                      <path d='M5.555 17.776l8-16 .894.448-8 16-.894-.448z' />
                    </svg>
                  )}
                  {crumb.href && !isLast ? (
                    <Link
                      to={crumb.href}
                      state={crumb.state}
                      className='text-gray-500 hover:text-gray-700 transition-colors duration-150'
                    >
                      {crumb.name}
                    </Link>
                  ) : (
                    <span
                      className={
                        isLast
                          ? 'text-gray-900 font-medium'
                          : 'text-gray-500'
                      }
                      aria-current={isLast ? 'page' : undefined}
                    >
                      {crumb.name}
                    </span>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      )}

      {/* Header content */}
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-2xl font-bold text-gray-900'>{title}</h1>
          {subtitle && <p className='mt-1 text-sm text-gray-600'>{subtitle}</p>}
        </div>

        {action && <div className='flex-shrink-0'>{action}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
